import { formatAccounting } from '@/lib/currency';
import { SummaryList, SummaryRow } from './SummaryList';
import type { CustomerSummaryDto } from '../types/jobCostOverview';

interface CustomerSummaryPanelProps {
  summary: CustomerSummaryDto;
}

/**
 * Balance Due renders in plain black with negatives (overpayments) in
 * parentheses. It previously used red for amounts due and green for overpaid;
 * the client asked for conventional accounting presentation instead
 * (Angie, Note 3).
 */
export function CustomerSummaryPanel({ summary }: CustomerSummaryPanelProps) {
  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="px-2 py-1.5 border-b border-border bg-gray-50 rounded-t-lg">
        <h4 className="text-xs font-semibold">Customer Summary</h4>
      </div>
      <SummaryList className="p-2">
        <SummaryRow label="Total Contracts" value={formatAccounting(summary.totalContracts)} />
        <SummaryRow label="Total Paid" value={formatAccounting(summary.totalPaid)} />
        <SummaryRow label="Balance Due" value={formatAccounting(summary.balanceDue)} emphasis />
      </SummaryList>
    </div>
  );
}
